import React, { useState, useEffect, createContext } from 'react';

export const ProductsContext = createContext();

export const ProductsProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [itemKeyword, setItemKeyword] = useState('');
  const [loading, setLoading] = useState(true);
  const [selectedProduct, setSelectedProduct] = useState({ imgs: [] });
  const [page, setPage] = useState(1);
  const [filterItems, setFilterItems] = useState([
    { category: 'shirt', active: false },
    { category: 'hoodie', active: false },
    { category: 'pants', active: false },
    { category: 'shorts', active: false },
    { category: 'jacket', active: false },
  ]);

  const API_URL=process.env.REACT_APP_API_URL;
  const API_MASTERKEY=process.env.REACT_APP_API_MASTERKEY;

  // useEffect(() => {
  //   setLoading(true);
  //   const fetchProducts = async () => {
  //     const apiUrl = itemKeyword
  //       ? `https://react-clothes-db.herokuapp.com/products?item=${itemKeyword}&_page=${page}&_limit=12`
  //       : `https://react-clothes-db.herokuapp.com/products?_page=${page}&_limit=12`;

  //     try {
  //       const resp = await fetch(apiUrl);
  //       const data = await resp.json();
  //       setProducts((prev) => [...prev, ...data]);
  //       setLoading(false);
  //     } catch (err) {
  //       console.log(err);
  //       setLoading(false);
  //     }
  //   };

  //   fetchProducts();
  // }, [itemKeyword, page]);


  useEffect(() => {
    setLoading(true);
    const fetchProducts = async () => {
      try {
        const resp = await fetch(API_URL, {
          headers: {
            'X-Master-Key': API_MASTERKEY
          }
        });
        const data = await resp.json();
        setProducts([...data.record.products]);
        setLoading(false);
      } catch (err) {
        setLoading(false);
      }
    }

    fetchProducts();
  }, [API_URL, API_MASTERKEY])


  // useEffect(() => {
  //   setPage(1);
  //   setProducts([]);
  // }, [itemKeyword]);

  return (
    <ProductsContext.Provider
      value={{
        setProducts,
        products,
        setItemKeyword,
        itemKeyword,
        loading,
        setLoading,
        selectedProduct,
        setSelectedProduct,
        setPage,
        page,
        filterItems,
        setFilterItems
      }}
    >
      {children}
    </ProductsContext.Provider>
  );
};
